import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
const USER_KEY = "passerelle-user";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = logged in

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      // Sans internet, on garde la session connue pour lire les contes gardés sur la tablette.
      const cached = !e.response && localStorage.getItem(USER_KEY);
      setUser(cached ? JSON.parse(cached) : false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
    else if (user === false) localStorage.removeItem(USER_KEY);
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (name, email, password, espace = "") => {
    const { data } = await api.post("/auth/register", { name, email, password, espace });
    setUser(data);
    return data;
  };

  const joinFamily = async (payload) => {
    const { data } = await api.post("/auth/register-family", payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, joinFamily, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
